import { isEmpty } from 'lodash'

export const onlyNumbersAndLetters = (value) => {
  if (isEmpty(value)) return ''
  return value.toUpperCase().replace(/[^0-9A-Z]/g, '')
}

export default onlyNumbersAndLetters
